export default "__VITE_ASSET__RktvK1RY__"